/*
 * @Author: PanYunhong
 * @Date: 2022-07-08 13:14:14
 * @LastEditors: PanYunhong
 * @LastEditTime: 2022-08-11 15:43:14
 */
import { get, post, } from '@/request/request';
import { serverIp, } from '@/configs/index';

/**
 *  气象关联分析
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const selectWeatherChart = (params:any) => post(`/analyze/selectWeatherChart`, params);

/**
 *  根据溯源点id查询单挑数据
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const getTraceInfo = (params:any) => get(`${serverIp}/gaochun/traceabilityAnalysis/info`, params);
